import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormArray,
  ValidatorFn,
} from "@angular/forms";
import { UnitaDocumentariaVO } from "@app/shared/vo/unita-documentariaVO";
import { MapperCreaPartenza } from "@app/shared/mapper/gescor/mapper-crea-partenza";
import { ClassificaService } from "@app/shared/services/classifica.service";
import { GescorService } from "@app/shared/services/gescor.service";
import { FormCreaCorrispondenzaPartenzaVO } from "@app/shared/vo/gescor/form-crea-corrispondenza-partenzaVO";
import { NotifierService } from "angular-notifier";
import { SettoreVO } from "@app/shared/vo/settoreVO";
import { TipoSupportoDocumentoEnum } from "@app/shared/enum/tipo-supporto-documento-enum";
import { TipoProtocolloEnum } from "@app/shared/enum/tipo-protocollo-enum";
import { ModaleEstensoriComponent } from "../modale-estensori/modale-estensori.component";
import { UtenteVO } from "@app/shared/vo/utenteVO";
import { DestinatarioDipendenteVO } from "@app/shared/vo/gescor/destinatario-dipendenteVO";
import { AttoVO } from "@app/shared/vo/attoVO";
import { Console } from "console";
import { AttoService } from "@app/shared/services/atto.service";
import { env } from "@env/environment";
const DestinatariValidator: ValidatorFn = (fg: FormGroup) => {
  console.log(
    "******formDestinatari",
    fg.get("formDestinatari.destinatari").value.length
  );
  const sizeDestinatari = fg.get("formDestinatari.destinatari").value.length;
  const sizeDestinatariInterni = fg.get(
    "formDestinatariInterni.destinatariInterni"
  ).value.length;
  const sizeDestinatariDipendenti = fg.get(
    "formDestinatariDipendenti.destinatariDipendenti"
  ).value.length;
  return sizeDestinatari > 0 ||
    sizeDestinatariInterni > 0 ||
    sizeDestinatariDipendenti > 0
    ? null
    : { range: true };
};
@Component({
  selector: "app-modale-destinatari",
  templateUrl: "./modale-destinatari.component.html",
})
export class ModaleDestinatariComponent implements OnInit {
  @ViewChild("templateDestinatari", { static: false })
  public destinatariModal: TemplateRef<any>;
  public modalRef: BsModalRef;
  disabledDip: boolean = true;
  inCreazione: boolean = false;

  creaCorrispondenzaPartenza: FormCreaCorrispondenzaPartenzaVO = new FormCreaCorrispondenzaPartenzaVO();
  @Input()
  unitaDocumentaria: UnitaDocumentariaVO;

  @Input()
  atto: AttoVO;

  @Input()
  strutturaResponsabile: SettoreVO;

  urlListaGescor: string;

  formPartenza: FormGroup;

  private config = {
    class: "modal-dialog modal-info modal-xlg",
    animated: true,
  };
  public firmatario: UtenteVO = null;

  @ViewChild("appModaleEstensori", { static: false })
  modaleEstensori: ModaleEstensoriComponent;

  primarioFirmato: boolean = false;
  richiediFirmatario: boolean;

  @Output()
  partenzaInseritaEmit: EventEmitter<boolean> = new EventEmitter<boolean>();
  bozzaDaAttoCreato: boolean;

  constructor(
    private modalService: BsModalService,
    private attoService: AttoService,
    private gescorService: GescorService,
    private fb: FormBuilder,
    private notifierService: NotifierService,
    private classificaService: ClassificaService,
    private mapperCreaPartenza: MapperCreaPartenza
  ) {
    console.log("MODALE DESTINATARI CONSTRUCTOR");
  }

  ngOnInit() {
    console.log("MODALE DESTINATARI INIT");
    this.inCreazione = false;
    this.urlListaGescor = env.URL_DETTAGLIO_PARTENZE_GESCOR;
  }
  public openModal(richiediFirmatario: boolean) {
    console.log("MODALE DESTINATARI OPENMODAL");

    console.log("richiediFirmatario", richiediFirmatario);
    this.richiediFirmatario = richiediFirmatario;
    this.bozzaDaAttoCreato = false;
    if (this.formPartenza !== undefined) {
      this.formPartenza.reset();
    }
    this.inCreazione = false;
    this.creaCorrispondenzaPartenza = new FormCreaCorrispondenzaPartenzaVO();

    this.formPartenza = this.fb.group(
      {
        oggetto: [""],
        classifica: [""],
        primario: [""],
        allegati: [""],
        mittente: [""],
        formDestinatari: this.fb.group({
          destinatarioSearch: [""],
          destinatari: new FormArray([]),
          tipoPartenzaHidden: [""],
        }),
        formDestinatariInterni: this.fb.group({
          settoreSearch: [""],
          destinatariInterni: this.fb.array([]),
        }),
        formDestinatariDipendenti: this.fb.group({
          dipendenteSearch: [""],
          destinatariDipendenti: this.fb.array([]),
        }),
        tipoProtocollo: [""],
      },
      { validator: DestinatariValidator }
    );

    if (this.unitaDocumentaria != null) {
      this.unitaDocumentaria.firmatario = null;
      this.creaCorrispondenzaPartenza = this.mapperCreaPartenza.convertUnitaDocumentariaVoToInterface(
        this.unitaDocumentaria
      );
      this.classificaService
        .getClassifica(this.unitaDocumentaria.classifica.codice)
        .subscribe((res) => {
          if (res[0].abilitaInvioComunicazioniDipendenti) {
            this.disabledDip = false;
            this.creaCorrispondenzaPartenza.classifica[0].abilitaInvioComunicazioniDipendenti = true;
          }
          this.formPartenza.patchValue(
            JSON.parse(JSON.stringify(this.creaCorrispondenzaPartenza))
          );
        });
    }
    else {
      this.creaCorrispondenzaPartenza = this.mapperCreaPartenza.convertAttoVoToInterface(
        this.atto
      );
      this.formPartenza.patchValue(
        JSON.parse(JSON.stringify(this.creaCorrispondenzaPartenza))
      );
    }

    this.modalRef = this.modalService.show(this.destinatariModal, this.config);
    this.disabledDip = true;

  }

  creaPartenza() {
    console.log("******** crea partenza ", this.unitaDocumentaria);
    if (
      this.unitaDocumentaria.tipo === TipoSupportoDocumentoEnum.DIGITALE &&
      (this.unitaDocumentaria.documentoPrimario.datiFirma === null ||
        this.unitaDocumentaria.documentoPrimario.datiFirma === undefined ||
        this.unitaDocumentaria.documentoPrimario.datiFirma.firmatario ===
        null ||
        this.unitaDocumentaria.documentoPrimario.datiFirma.firmatario ===
        undefined ||
        this.unitaDocumentaria.documentoPrimario.datiFirma.firmatario
          .cognome === "") &&
      (this.unitaDocumentaria.firmatario === null ||
        this.unitaDocumentaria.firmatario === undefined)
    ) {
      this.scegliOperatore();
    } else {
      this.inserisciPartenza();
    }
  }

  public valorizzaFirmatario() {
    const settoreFirmatario: SettoreVO = new SettoreVO();
    settoreFirmatario.codice = this.strutturaResponsabile.codice;
    settoreFirmatario.nome = this.strutturaResponsabile.nome;
    this.creaCorrispondenzaPartenza.settoreFirmatario = settoreFirmatario;
  }

  public inserisciPartenza() {
    this.inCreazione = true;
    this.impostaVO();
    this.valorizzaFirmatario();
    if (this.unitaDocumentaria != null) {
      this.gescorService.creaPartenza(this.creaCorrispondenzaPartenza).subscribe(
        (res) => {
          this.ngOnInit();
          this.inCreazione = false;
          this.modalRef.hide();
          this.notifierService.notify(
            "success",
            "Partenza predisposta con successo!"
          );
          this.partenzaInseritaEmit.emit(true);
        },
        (err) => {
          console.log("errore ", err);
          this.modalRef.hide();
        }
      );
    } else {
      this.attoService.creaPartenzaBozza(this.creaCorrispondenzaPartenza, this.atto.id).subscribe(
        (res) => {
          this.ngOnInit();
          this.inCreazione = false;
          //  this.modalRef.hide();
          this.notifierService.notify(
            "success",
            "Partenza in bozza su GesCor predisposta con successo!"
          );
          this.partenzaInseritaEmit.emit(true);
          this.bozzaDaAttoCreato = true;
          this.urlListaGescor = this.urlListaGescor + res.split("/").pop();

        },
        (err) => {
          console.log("errore ", err);
          this.modalRef.hide();
        }
      );
    }
  }

  async scegliOperatore() {
    this.modaleEstensori.openModal(this.unitaDocumentaria.struttura, true);
  }

  impostaVO() {
    console.log(
      "impostaVO this.creaCorrispondenzaPartenza.primario",
      this.creaCorrispondenzaPartenza.primario
    );
    this.creaCorrispondenzaPartenza.oggetto = this.formPartenza.value.oggetto;
    this.creaCorrispondenzaPartenza.mittente = this.strutturaResponsabile;
    this.creaCorrispondenzaPartenza.destinatariInterni = this.formPartenza.value.formDestinatariInterni.destinatariInterni;
    this.creaCorrispondenzaPartenza.destinatariDipendenti = new Array<
      DestinatarioDipendenteVO
    >();
    this.formPartenza.value.formDestinatariDipendenti.destinatariDipendenti.forEach(
      (element) => {
        const destDip = new DestinatarioDipendenteVO();
        destDip.competenza = element.competenza;
        const dipendente = element.dipendente;

        destDip.dipendente = dipendente;
        this.creaCorrispondenzaPartenza.destinatariDipendenti.push(destDip);
      }
    );
    if (this.unitaDocumentaria != null) {

      if (this.unitaDocumentaria.tipo === TipoSupportoDocumentoEnum.DIGITALE) {
        this.creaCorrispondenzaPartenza.formDestinatari.destinatari = this.formPartenza.value.formDestinatari.destinatari;
        if (
          this.creaCorrispondenzaPartenza.formDestinatari.destinatari.length > 0
        ) {
          this.creaCorrispondenzaPartenza.tipoProtocollo =
            TipoProtocolloEnum.PARTENZA_DIGITALE;
        } else {
          this.creaCorrispondenzaPartenza.tipoProtocollo =
            TipoProtocolloEnum.INTERNO_DIGITALE;
        }
      } else {
        this.creaCorrispondenzaPartenza.formDestinatariCartacei.destinatari = this.formPartenza.value.formDestinatari.destinatari;
        this.creaCorrispondenzaPartenza.tipoProtocollo =
          TipoProtocolloEnum.PARTENZA_CARTACEO;
      }
      this.creaCorrispondenzaPartenza.idUnitaDocumentaria = this.unitaDocumentaria.id;
      this.creaCorrispondenzaPartenza.firmatario = this.unitaDocumentaria.firmatario;
    } else {
      this.creaCorrispondenzaPartenza.formDestinatari.destinatari = this.formPartenza.value.formDestinatari.destinatari;
      if (
        this.creaCorrispondenzaPartenza.formDestinatari.destinatari.length > 0
      ) {
        this.creaCorrispondenzaPartenza.tipoProtocollo =
          TipoProtocolloEnum.PARTENZA_DIGITALE;
      } else {
        this.creaCorrispondenzaPartenza.tipoProtocollo =
          TipoProtocolloEnum.INTERNO_DIGITALE;
      }
    }

    console.log("impostaVO", this.creaCorrispondenzaPartenza);
  }
}
